<template>
    <div class="single-selector">
        <div v-for="(item, i) in answer" :key="i" class="single">
            <label v-if="item.etc" class="label-radio etc_label">
                <input
                    type="radio"
                    class="single__pick"
                    :name="`q_${mode}_${no_plus}`"
                    value="etc"
                    :checked="!disabled_check"
                    @click="focusHandler"
                />
                <div class="label-input-visible">
                    <div class="label-input-visible__checkbox"></div>
                    <div>기타</div>
                </div>
                <div>
                    <input type="text" v-model="_etc" ref="etc_input_single" :disabled="disabled_check" />
                </div>
            </label>

            <label v-else class="label-radio">
                <input
                    type="radio"
                    v-model="_value"
                    class="single__pick"
                    :name="`q_${mode}_${no_plus}`"
                    :value="i"
                    :disabled="isFirstComeClosed(i)"
                />

                <div class="label-input-visible" @mousedown="singleClickHandler(i, $event)">
                    <div class="label-input-visible__checkbox"></div>
                    <div class="label-input-visible__answer" v-html="item.value"></div>
                    <div class="label-input-visible__first-come" v-if="firstComeByAnswer" v-html="getFirstComeRemained(item)"></div>
                </div>
                <div v-if="item.imgUrl" class="single__img">
                    <img :src="item.imgUrl" />
                </div>
            </label>
        </div>
        <button v-if="!isInput && hasSelection" type="button" class="single-selector__clear" @click="clearSelection">
            선택 해제
        </button>
    </div>
</template>

<script>
import { hasOwnProperty } from "@/lib/core";

export default {
    name: "SingleSelector",
    data: () => ({
        temp: ""
    }),
    props: ["answer", "no", "mode", "parentNo", "type", "value", "isInput", "firstComeByAnswer", "onChange", "onError", "onEtcChange"],
    computed: {
        _value: {
            get() {
                if (typeof this.value[0] === "number") {
                    return this.value[0];
                } else {
                    return null;
                }
            },
            set(value) {
                const { no, type, parentNo } = this;
                this.onChange({ no, parentNo, value, type });
            }
        },
        _etc: {
            get() {
                if (!this.disabled_check) {
                    return this.value[0].etc;
                } else {
                    return "";
                }
            },
            set(value) {
                this.temp = value;
                const { no, parentNo } = this;
                this.onEtcChange({ no, parentNo, value });
            }
        },

        no_plus() {
            if (this.parentNo) {
                return this.no + 1 + "_" + this.parentNo;
            }
            return this.no + 1;
        },

        disabled_check() {
            if (typeof this.value[0] === "object" && hasOwnProperty(this.value[0], "etc")) {
                return false;
            } else {
                return true;
            }
        },

        hasSelection() {
            if (!this.value.length) {
                return false;
            }

            if (typeof this.value[0] === "number") {
                return true;
            }

            return typeof this.value[0] === "object" && hasOwnProperty(this.value[0], "etc");
        }
    },
    methods: {
        focusHandler(e) {
            const { value } = e.target;
            const { no, type, parentNo } = this;
            this.onChange({ no, parentNo, value, type });

            setTimeout(() => {
                this.$refs.etc_input_single[0].focus();
                this.$refs.etc_input_single[0].value = this.temp;
                this.onEtcChange({ no, parentNo, value: this.temp });
            }, 100);
        },

        singleClickHandler(value, event) {
            if (this.isFirstComeClosed(value)) {
                event.preventDefault();
                this.onError("answer_out_of_first_come");
            }
        },

        clearSelection() {
            const { no, type, parentNo } = this;
            this.onChange({ no, parentNo, value: null, type });
        },

        isFirstComeClosed(value) {
            return this.firstComeByAnswer && this.answer[value].remainingCount === 0;
        },

        getFirstComeRemained(item) {
            if (item.firstCome && item.firstCome !== 0) {
                if (item.remainingCount !== 0) {
                    return item.remainingCount + "명 남음";
                } else {
                    return "선착순 마감";
                }
            } else {
                return "선착순 제한 없음";
            }
        }
    },
    mounted() {
        if (!this.disabled_check) {
            this.temp = this.value[0].etc;
        }
    }
};
</script>

<style lang="scss">
.single-selector {
    &__clear {
        cursor: pointer;
        display: inline-block;
        margin-top: 12px;
        padding: 0;
        border: none;
        background-color: transparent;
        font-size: 14px;
        color: #686868;
        text-decoration: underline;
    }
}

.single {
    font-size: 0;

    & + & {
        margin-top: 16px;
    }

    label {
        cursor: pointer;
        display: inline-block;
    }

    .etc_label > div input {
        margin-top: 8px;
    }

    &__pick {
        &:checked {
            & + .single__img {
                border: 2px solid #f4b643;
            }
        }
    }

    &__img {
        width: 260px;
        height: 200px;
        text-align: center;
        margin-bottom: 20px;
        border: 2px solid #ffffff;
        padding: 16px;

        img {
            height: 100%;
            display: inline-block;
            border: 0;
            font-size: 0;
        }
    }
}
</style>
